import Vue from 'vue';
import VueBackbone from 'vue-backbone';

import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';

import SearchAdvancedFiltersMixin from './search_advanced_filters_mixin';

const view = Object.assign(
  {
    initialize(options) {
      Vue.use(VueBackbone);

      this.filters = options.filters;
      const filtersApp = this.initAdvancedFilters('.js-advanced-mobile-modal-filters');
      const $countDisplay = $('.js-advanced-filters-count');
      filtersApp.$watch('selectedFiltersCount', val => {
        if (val === 0) $countDisplay.text('');
        else $countDisplay.text(`(${val})`);
      });
    },
  },
  SearchAdvancedFiltersMixin
);

export default Backbone.View.extend(view);



// WEBPACK FOOTER //
// ./js/backbone/views/search/mobile_advanced_search_filters_view.js